import * as React from 'react'
import { useParams } from 'react-router-dom'

import { ItemDetailPageDocument } from 'generated/resources/graphql'

import { useMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import TaskElement from 'modules/tasks/components/TaskElement'
import { TaskIdentifier } from 'modules/tasks/lib/task'

import { useMaterializedProcessContext } from '../MaterializedProcessPage'

const ItemDetailPage = () => {
  const { materializedItemId } = useParams()

  const { materializedProcess } = useMaterializedProcessContext()

  const materializedItem = useMemo(() => {
    if (!materializedItemId || !materializedProcess) return

    return materializedProcess.materializedSteps
      .flatMap((step) => step.materializedItems)
      .find((item) => item.id === Number(materializedItemId))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materializedItemId])

  const { data, loading } = useQuery(ItemDetailPageDocument)
  const canEmployeeManageAnyEmployeeFolder =
    data?.documents._policies.employeeManageAnyEmployeeFolder.can ?? false

  return (
    <TaskElement
      identifier={TaskIdentifier.Workflow}
      taskId={Number(materializedItem?.resourceId)}
      contractVersions={contractVersions}
      canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
      loading={loading}
    />
  )
}

export default ItemDetailPage
